import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as DataAccessPostsActions from './data-access-posts.actions';
import * as DataAccessPostsSelectors from './data-access-posts.selectors';

@Injectable()
export class DataAccessPostsFacade {
  post$ = this.store.pipe(select(DataAccessPostsSelectors.getPost));
  postLoading$ = this.store.pipe(select(DataAccessPostsSelectors.getActivePostLoading));
  postError$ = this.store.pipe(select(DataAccessPostsSelectors.getActivePostError));
  exhibitorPosts$ = this.store.pipe(select(DataAccessPostsSelectors.getPostExhibitorPosts));
  postPosts$ = this.store.pipe(select(DataAccessPostsSelectors.getPostPosts));

  constructor(private readonly store: Store) {}

  pageOpened(postId: string, fairId?: string) {
    this.store.dispatch(DataAccessPostsActions.postOpened({ postId: postId, fairId: fairId }));
  }

  getPostById(postId: string) {
    return this.store.pipe(select(DataAccessPostsSelectors.getPostById, { postId }));
  }
}
